<div id="checkout-container">
    <div class="checkout-flex-container">
        <div class="checkout-box" id="items-box">
            <ng-container *ngTemplateOutlet="selectedMeals"></ng-container>
            <ng-container *ngIf="addons && addons.length > 0">
                <div class="addons-mobile-only">
                    <ng-container *ngTemplateOutlet="addOns"></ng-container>
                </div>
            </ng-container>
        </div>
        <div class="checkout-box" id="order-summary-box">
            <ng-container *ngTemplateOutlet="orderSummary"></ng-container>
            <app-disclaimer></app-disclaimer>
        </div>
    </div>
    <ng-container *ngIf="addons && addons.length > 0">
        <div class="addons-desktop-only">
            <ng-container *ngTemplateOutlet="addOns"></ng-container>
        </div>
    </ng-container>
</div>


<ng-template #addOns>
    
    <div class="meals-container addons-container">
        
        
        
        <div class="content-section">
            <div class="divider-container">
                <div class="divider-line"></div>
            </div>
            <div class="plan-header">
                <div class="plan-title-row">
                    <div class="plan-title plan-title-dark">Feeling peckish?</div>
                </div>
                <div>Choose from our selection of handcrafted Add-Ons</div>
            </div>
        </div>

        <!-- AddOns -->

        <ng-container>
            <div class="meals-wrapper">
                <button class="scroll-arrow left-arrow" (click)="scrollLeft('addons')">
                    <i class="pi pi-chevron-left"></i>
                </button>
                <div class="meals-scroll-container" #addonsContainer (mouseenter)="pauseAddonsScroll()" (mouseleave)="resumeAddonsScroll()" *ngIf="preSelectedWeekAddOns && preSelectedWeekAddOns.length > 0">
                    <ng-container *ngFor="let copy of [0, 1]">
                        <app-new-meal-card  [meal]="meal" [isCurrentMenu]="false" *ngFor="let meal of preSelectedWeekAddOns" (addMeal)="addAddonToCart(meal)" (removeMeal)="removeAddonFromCart(meal)" (increaseQuantity)="increaseAddonQuantity(meal)" (decreaseQuantity)="decreaseAddonQuantity(meal)" [hideNutrition]="true"></app-new-meal-card>
                    </ng-container>
                </div>
                <div class="meals-scroll-container" #addonsContainer (mouseenter)="pauseAddonsScroll()" (mouseleave)="resumeAddonsScroll()" *ngIf="!preSelectedWeekAddOns || preSelectedWeekAddOns.length === 0">
                    <ng-container *ngFor="let copy of [0, 1]">
                        <app-new-meal-card  [meal]="meal" [isCurrentMenu]="false" *ngFor="let meal of addons" (addMeal)="addAddonToCart(meal)" (removeMeal)="removeAddonFromCart(meal)" (increaseQuantity)="increaseAddonQuantity(meal)" (decreaseQuantity)="decreaseAddonQuantity(meal)" [hideNutrition]="true"></app-new-meal-card>
                    </ng-container>
                </div>
                <button class="scroll-arrow right-arrow" (click)="scrollRight('addons')">
                    <i class="pi pi-chevron-right"></i>
                </button>
            </div>

            <!--
            <div class="change-meals-section">
                <div class="change-meals-button" (click)="editMeals()">
                    <div class="change-meals-text">Change Add Ons</div>
                </div>
            </div>
            -->
         </ng-container>
         
    </div>
    
</ng-template>


<ng-template #selectedMeals>
    
    <div class="meals-container">
        <div class="divider-container">
            <div></div>
        </div>
        <div class="delivery-section">
            <span class="delivery-label">First delivery on:</span>&nbsp;
            <span class="delivery-dropdown">
                <p-dropdown [options]="dates" optionLabel="name" [showClear]="false" [(ngModel)]="selectedDate" placeholder="Pick an option">
                    <ng-template let-date pTemplate="item">
                        <div class="d-flex align-items-center gap-2" style="justify-content: space-between;" [style]="!isMobile ? 'width: 320px !important' : ''">
                            <div (click)="selectedDate = date; setDate(date)" class="dropdown-item">{{ date.name }}</div>
                            <p-radioButton [inputId]="date.key" name="date" [value]="date" [(ngModel)]="selectedDate" (ngModelChange)="setDate($event)" *ngIf="!isMobile"></p-radioButton>
                        </div>
                    </ng-template>
                </p-dropdown>
            </span>
        </div>
        <div class="content-section">
            <div class="divider-container">
                <div class="divider-line"></div>
            </div>
            <div class="plan-header">
                <div class="plan-title-row">
                   <div class="plan-title">We picked for you:</div>
                   <!--
                   <div class="plan-summary-info">
                       <span>{{getGoalLabel()}}</span>
                       <span>{{planOrderDetails.mealPerDay}} meals/day</span>
                       <span>{{planOrderDetails.dayPerWeek}} days/week</span>
                   </div>
                   -->
                </div>
            </div>
            <!--
            <div class="meals-count">
                <div class="meals-count-text">16 main meals</div>
            </div>
            -->
        </div>

        <!-- Meals -->

        <!-- Empty Result -->
        <div class="meals-wrapper" *ngIf="!preSelectedWeekMeals || preSelectedWeekMeals?.length === 0" style="position: relative;">

            <ngx-spinner type="ball-spin-clockwise" bdColor="rgb(249, 249, 251)" size="medium" color="#ef870a" [fullScreen]="false"></ngx-spinner> 
            
            <ng-container *ngIf="!isLoading">
                <div class="error-message-no-meals">
                    Sorry there are not enough meals matching your criteria to cover the whole week.<br>
                    Try different Days/Weeks combination, Categories, Goals, and/or Allergies
                </div>

                <div class="change-meals-section">
                    <div class="change-meals-button">
                        <div (click)="goToQuestions()" class="change-meals-text">Back to Questions</div>
                    </div>
                </div>
            </ng-container>
        </div>

        <!-- With Result -->
        <ng-container *ngIf="preSelectedWeekMeals && preSelectedWeekMeals.length > 0">
            <div class="meals-wrapper">
                <button class="scroll-arrow left-arrow" (click)="scrollLeft('meals')">
                    <i class="pi pi-chevron-left"></i>
                </button>
                <div class="meals-scroll-container" #mealsContainer>
                    <app-new-meal-card [meal]="meal" [isCurrentMenu]="true" *ngFor="let meal of preSelectedWeekMeals"></app-new-meal-card>
                </div>
                <button class="scroll-arrow right-arrow" (click)="scrollRight('meals')">
                    <i class="pi pi-chevron-right"></i>
                </button>
            </div>

            <div class="change-meals-section">
                <div class="change-meals-button" (click)="editMeals()">
                    <div class="change-meals-text">Change Meals</div>
                </div>
            </div>
         </ng-container>
    </div>
    
</ng-template>


<ng-template #myBasket>
        <div class="basket-container">
            <div class="card-body m-3">
                <p-divider></p-divider>
                <div *ngIf="getMealsFromCart().length > 0">
                    <div *ngFor="let item of getMealsFromCart()">
                        <span class="fm-rubik meal-item-count">{{item.count}} x </span>
                        <span class="fm-rubik meal-item-text">{{item.name}}</span>
                    </div>
                </div>
            </div>
        </div>
</ng-template>

<ng-template #addonsBasket>
        <div class="basket-container">
            <div class="card-body m-3">
                <p-divider></p-divider>
                <div *ngIf="getAddonsFromCart().length > 0">
                    <div *ngFor="let item of getAddonsFromCart()" >
                        <span class="fm-rubik meal-item-count">{{item.count}} x </span>
                        <span class="fm-rubik meal-item-text">{{item.name}}</span>
                    </div>
                </div>
            </div>
        </div>
</ng-template>

<ng-template #orderSummary>
         <div class="order-summary-container">
            <div id="order-summary">
                <div>Order Summary</div>
            </div>
            <div style="margin-top: 35px">
                <!--
                <div style="display: flex; justify-content: space-between; align-items: baseline;">
                    <span class="order-summary-label">Plan</span>&nbsp;
                    <span class="order-summary-data">{{planOrderDetails.type}}</span>
                </div>
                -->
                <p-divider></p-divider>
                <div>
                    <span class="order-summary-label"><img src="assets/images/delivery-van-icon.svg"/>&nbsp;&nbsp;Total Deliveries</span>
                    <span class="order-summary-data">{{weeklyDeliveriesCount}}</span>
                </div>
                <p-divider></p-divider>
                <div style="display: flex; justify-content: space-between; align-items: baseline;">
                    <span class="order-summary-label">First delivery on</span>&nbsp;
                    <span class="order-summary-data">{{deliveryDate}}</span>
                </div>
                <p-divider></p-divider>
                <div style="display: flex; justify-content: space-between; align-items: baseline;">
                    <span class="order-summary-label">{{countTotalMeals(getMealsFromCart())}} meals<i class="pi" [ngClass]="showMainCheckout ? 'pi-chevron-up' : 'pi-chevron-down'" style="cursor: pointer; margin-left: 8px;" (click)="showMainCheckout = !showMainCheckout"></i></span>&nbsp;
                    <span class="order-summary-data">£{{getWeekSubTotalPrice()}}</span>
                </div>
                <div *ngIf="showMainCheckout">
                    <ng-container *ngTemplateOutlet="myBasket"></ng-container>
                </div>
                
                <p-divider *ngIf="getAddonsFromCart().length > 0"></p-divider>
                <div *ngIf="getAddonsFromCart().length > 0" style="display: flex; justify-content: space-between; align-items: baseline;">
                    <span class="order-summary-label">{{countTotalAddOns(getAddonsFromCart())}} add-ons<i class="pi" [ngClass]="showAddOnsCheckout ? 'pi-chevron-up' : 'pi-chevron-down'" style="cursor: pointer; margin-left: 8px;" (click)="showAddOnsCheckout = !showAddOnsCheckout"></i></span>
                    <span class="order-summary-data">£{{getAddonsSubTotalPrice()}}</span>
                </div>
                <div *ngIf="showAddOnsCheckout && getAddonsFromCart().length > 0">
                    <ng-container *ngTemplateOutlet="addonsBasket"></ng-container>
                </div>
                
                <p-divider *ngIf="+discountVisual() > 0"></p-divider>
                <div *ngIf="+discountVisual() > 0">
                    <span class="order-summary-label">Discount <span id="discount-circle">{{discount}}% off</span></span>
                    <span class="order-summary-data">- £{{discountVisual()}}</span>
                </div>
                
                <p-divider></p-divider>
                <div>
                    <span class="order-summary-label">Delivery fee</span>
                    <span *ngIf="getDeliveryFeesFirstWeek() > 0" style="float: right;font-size: 0.857rem;color: #5D5D66;">+ £{{getDeliveryFeesFirstWeek()}}</span>
                    <span *ngIf="getDeliveryFeesFirstWeek() == 0 && free_shipping_type == 'entire_order'" style="float: right;font-size: 0.857rem;color: #F8A94A;"><b>FREE</b></span>
                    <span *ngIf="getDeliveryFeesFirstWeek() == 0 && free_shipping_type == 'first_week'" style="float: right;font-size: 0.857rem;color: #F8A94A;"><b>1st week FREE</b></span>
                </div>
                <p-divider></p-divider>
                <span class="order-summary-promo-code-label">Promo code</span>
                <div class="d-flex" style="position: relative;">
                    <input type="text" class="input-promo-discount" placeholder="type here ..." [(ngModel)]="promo_code" />
                    <button class="btn weight-500 btn-apply" (click)="applyDiscount()">Apply</button>
                </div>
                <span *ngIf="promo_discount_object && promo_discount_object.discount.firstWeekDiscount" style="color: green;font-weight: 500;">{{promo_discount_object.discount.firstWeekDiscount + '% off + ' + promo_discount_object.discount.discount + '% + ' + promo_discount_object.discount.discount + '% + ' + promo_discount_object.discount.discount + '%'}}</span>
                <p-divider></p-divider>
                <div>
                    <span class="order-summary-total-price-label"><span *ngIf="planOrderDetails.type!='Flexi'">Week</span> Total</span>
                    <span class="order-summary-total-price-data"><del style="color: grey;font-weight: 400;font-style: italic;" *ngIf="promo_discount_id">£{{getWeekDefaultTotalPrice()}}</del><span> £{{getFirstWeekTotalPrice()}}</span></span>
                </div>
                <div>
                    <span ></span>
                    <span class="order-summary-total-price-data" style="color:green">£{{getDiscountedMealPrice()}} per serving<span *ngIf="promo_discount_id">*</span></span>
                    <span *ngIf="promo_discount_id">*Discount applies to subscription plans only</span>
                </div>
            </div>
            <div class="btn-checkout" (click)="goToOrderCheckout()" *ngIf="preSelectedWeekMeals && preSelectedWeekMeals.length > 0">
                <div>Checkout</div>
            </div>
        </div>
</ng-template>